import client from './client';
import { TimesheetType } from '../interfaces/TimesheetInterface';
import config from '../configLoader';

export const getSupervisors = async (payPeriodID: number, type: TimesheetType, adminUserEmployeeID?: number) => {
    try {
      // Map the enum values to their corresponding endpoints
      let endpointMap: { [key in TimesheetType]: string } = {
        [TimesheetType.Unsubmitted]: "/admin/timesheets/unsubmitted/supervisorList",
        [TimesheetType.ManagerPending]: "/admin/timesheets/managerPending/approverList",
        [TimesheetType.Submitted]: "/admin/timesheets/submitted/supervisorList",
        [TimesheetType.SuperApproved]: "/admin/timesheets/supervisorApproved/supervisorList",
        [TimesheetType.PayApproved]: "/admin/timesheets/payrollApproved/supervisorList"
      };

      // If useRequiredSuperApproval is true, use the required supervisor endpoint for submitted type
      if (config.useRequiredSuperApproval && type === TimesheetType.Submitted) {
        endpointMap[TimesheetType.Submitted] = "/admin/timesheets/submitted/requiredSupervisorList";
      }

      // Use the enum to determine the appropriate endpoint
      const endpoint = endpointMap[type] || "/admin/timesheets";

      // Approval Access (WP8 / D3): the server derives the calling admin from the MSAL
      // session and scopes the supervisor list server-side. adminUserEmployeeID is no
      // longer sent for authorization (kept in the signature for caller compatibility).
      const response = await client.get(endpoint, {
        params: {
          payPeriodID,
        }
      });
      return response;

    } catch (error) {
      // Log any errors encountered during the fetch process
      console.error("Error fetching timesheet counts:", error);
      // Throw an error to indicate failure in fetching the supervisor data
      throw new Error("Failed to fetch timesheet counts");
    }
};

export const getEmployeeTimesheet = async (employeeID: number, payPeriodID: number) => {
    try {
      const response = await client.get('/admin/timesheets/getEmployeeTimesheet', {
        params: { employeeID, payPeriodID }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching employee timesheet:', error);
      throw error;
    }
};

export const getUnsubmittedEmployeeTimesheet = async (employeeID: number, payPeriodID: number) => {
  try {
    const response = await client.get('/admin/timesheets/getUnsubmittedEmployeeTimesheet', {
      params: { employeeID, payPeriodID }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching employee timesheet:', error);
    throw error;
  }
};
